import {
  REQUEST_SUCCESS_CODE,
  VEHICLE_TYPE_ARR,
  ORDER_STATUS_SUCCESS,
  ORDER_STATUS_ARREARS,
  PAYWAY_TYPE_ARR
} from "../config/config";

let conditionMethod = {
  //是否请求服务器
  isDev() {
    if (process.env.NODE_ENV === "development") {
      return true;
    } else {
      return false;
    }
  },

  isOnline() {
    let isTest = false;
    console.log(123123);
    return conditionMethod.isDev() ? isTest : false;
  },

  //是否请求成功
  isRequestSuccess(obj) {
    if (obj["code"] == REQUEST_SUCCESS_CODE) {
      return true;
    } else {
      return false;
    }
  },
  //订单支付中状态  code  10  U  Q
  isOrderStatus_abnormal(code) {
    if (code == 10 || code == "U" || code == "Q") {
      return true;
    } else {
      return false;
    }
  },
  //订单支付失败状态  code  14 N
  isOrderStatus_fail(code) {
    if (code == 14 || code == "N") {
      return true;
    } else {
      return false;
    }
  },
  //订单支付成功状态  code  20
  isOrderStatus_success(code) {
    if (code == 20 || code == "Y") {
      return true;
    } else {
      return false;
    }
  },
  //订单待处理状态  code  0
  isOrderStatus_pending(code) {
    if (code == 0 || code == 17 || code == 18) {
      return true;
    } else {
      return false;
    }
  },

  //订单欠费状态  code  50
  isOrderStatus_arrears(code) {
    if (code == 50) {
      return true;
    } else {
      return false;
    }
  },

  isOrderStatus_advance(code) {
    if (code == 16) {
      return true;
    } else {
      return false;
    }
  },

  //订单状态
  isArrears(status) {
    if (status == ORDER_STATUS_ARREARS) {
      return true;
    } else if (status == ORDER_STATUS_SUCCESS) {
      return false;
    } else {
      return false;
    }
  },

  //车类型
  vehicleTypeTest(type) {
    let arr = VEHICLE_TYPE_ARR;
    for (let i = 0; i < arr.length; i++) {
      if (arr[i]["code"] == type) {
        return arr[i]["text"];
      }
    }
    return "未知";
  },

  payWayTest(type) {
    let arr = PAYWAY_TYPE_ARR;
    for (let i = 0; i < arr.length; i++) {
      if (arr[i]["code"] == type) {
        return arr[i]["text"];
      }
    }
    return "未知";
  }
};

export default conditionMethod;
